import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES =
  "SET_IS_FETCHING_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES";
export const SET_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES =
  "SET_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES";

const mutations = {
  [SET_IS_FETCHING_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES]: setStoreValue(
    "isFetchingOrganisationInterviewFormatTemplates"
  ),
  [SET_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES]: setStoreValue(
    "organisationInterviewFormatTemplates"
  )
};

const state = {
  organisationInterviewFormatTemplates: [],
  isFetchingOrganisationInterviewFormatTemplates: false
};

export { mutations, state };
